import styled from 'styled-components';
import { AvatarSize } from './Avatar';

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 100%;
  overflow: hidden;

  ${({ size }) =>
    size === AvatarSize.REGULAR &&
    `
    height: 60px;
    width: 60px;
  `}

  ${({ size }) =>
    size === AvatarSize.LARGE &&
    `
    height: 90px;
    width: 90px;
  `}

  ${({ size }) =>
    size === AvatarSize.SMALL &&
    `
    height: 30px;
    width: 30px;
  `}
`;

export const StyledImage = styled.img`
  width: 100%;
  height: auto;
`;
